"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoLauncher = void 0;
class VideoLauncher {
    constructor() {
        this.observer = new IntersectionObserver(this.observerFunction);
    }
    observerFunction(entries) {
        entries.forEach((entry) => {
            const video = entry.target;
            if (!entry.isIntersecting && !video.paused)
                video.pause();
            if (entry.isIntersecting && video.paused) {
                video.play().then(() => video.removeAttribute('controls')).catch(() => video.setAttribute('controls', 'true'));
            }
        });
    }
    addPlayButton(video) {
        const playButton = document.createElement('button');
        const play = () => video.play().catch(() => {
            video.setAttribute('controls', 'true');
            playButton.remove();
        });
        playButton.setAttribute('type', 'button');
        playButton.classList.add('IH');
        playButton.setAttribute('aria-hidden', 'true');
        playButton.addEventListener('click', play, { once: true });
        document.body.appendChild(playButton);
        playButton.click();
    }
    watch(video) {
        this.addPlayButton(video);
        this.observer.observe(video);
    }
    disconnect() {
        this.observer.disconnect();
    }
}
exports.VideoLauncher = VideoLauncher;
